'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'image';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = ['M32 64l448 0 0 201.4-84.7-84.7L384 169.4l-11.3 11.3L224 329.4l-84.7-84.7L128 233.4l-11.3 11.3L32 329.4 32 64zm64 80a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z', 'M32 64l0 265.4 84.7-84.7L128 233.4l11.3 11.3L224 329.4 372.7 180.7 384 169.4l11.3 11.3L480 265.4 480 64 32 64zm0 310.6L32 448l73.4 0 96-96L128 278.6l-96 96zm352-160L150.6 448 480 448l0-137.4-96-96zM0 32l32 0 448 0 32 0 0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32zM160 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;